function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.795 15.875L5.325 12.405C5.13817 12.2178 4.88452 12.1125 4.62 12.1125C4.35548 12.1125 4.10183 12.2178 3.915 12.405C3.525 12.795 3.525 13.425 3.915 13.815L8.095 17.995C8.485 18.385 9.115 18.385 9.505 17.995L20.085 7.41501C20.475 7.02501 20.475 6.39501 20.085 6.00501C19.8982 5.81776 19.6445 5.71252 19.38 5.71252C19.1155 5.71252 18.8618 5.81776 18.675 6.00501L8.795 15.875Z",
    fill: "#9da3a8"
  }));
};
export default SvgComponent;
//# sourceMappingURL=check.js.map